import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { UserInterface } from 'app/models/user.model';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';

@Injectable({
  providedIn: 'root',
})
export class UserDataTransformPost extends DataTransformAbstractPost {
  constructor(protected datePipe: DatePipe) {
    super();
  }

  transform(user: UserInterface): UserInterface {
    if (Array.isArray(user.customers)) {
      user.customers = <any>user.customers.map((v) => v.id);
    }
    return user;
  }
}
